module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "up-box"
  }, [_c('el-upload', {
    class: {
      isUpload: !!_vm.imgUrl
    },
    attrs: {
      "disabled": !_vm.disabled,
      "action": _vm.actionUrl,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.onRemove,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.imgUrl ? [{
        url: _vm.imgUrl
      }] : [],
      "name": "uploadFile"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f33fb08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UploadImg.vue
// module id = 942
// module chunks = 0